import Vue from 'vue'
import store from './store';

import ProductConfigurator from './ProductConfigurator'
import PortalVue from 'portal-vue';

Vue.use(PortalVue)

Vue.component('product-configurator', ProductConfigurator);

new Vue({
    el: '#product_configurator',
    store,
})